/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shared_FlexibleDate } from './shared_FlexibleDate';
export type capacity_MoveAllocationsRequest = {
    /**
     * AcknowledgedBreach records that the operator explicitly acknowledged a
     * critical over-capacity breach (C19). Audit carrier only — it never gates
     * or relaxes any server-side rule.
     */
    acknowledged_breach?: boolean;
    /**
     * AgeType is AUTO (derive per period from the billing age-transition rules),
     * BABY or CHILD (pin a literal age type for the whole period).
     */
    age_type: capacity_MoveAllocationsRequest.age_type;
    /**
     * ChildIDs are the children to move. Element length is bounded with `dive`
     * (a bare `max` would bound the slice length, not the ids). `unique`
     * rejects a repeated id at the boundary: duplicates double-count the child
     * in the projection and make the commit end the same allocation twice,
     * which surfaces as a 409 blaming a concurrent writer that never existed.
     */
    child_ids: Array<string>;
    /**
     * DryRun projects the move and writes nothing. It is a required pointer on
     * purpose: a bare bool would make an omitted dry_run mean "commit", so a
     * client that forgets the field would silently write instead of preview.
     */
    dry_run: boolean;
    /**
     * EffectiveDate is the day the new placement starts. Optional: when omitted
     * it defaults to the 1st of the next month.
     */
    effective_date?: shared_FlexibleDate;
    /**
     * ExpectedUpdatedAt maps child_id -> the RFC3339-with-sub-second-precision
     * (RFC3339Nano on the wire) updated_at the client last saw on that child's
     * current allocation. Optional; a present-but-stale value yields 409. The
     * value the API emitted must round-trip byte-for-byte back into the
     * updated_at equality guard, so the fractional seconds must survive.
     *
     * Three bounds, and the tag order matters in go-playground/validator: the
     * leading `max=200` bounds the ENTRY COUNT (matching the ChildIDs cap, since
     * the handler materialises the whole map before calling the service),
     * `keys …endkeys` bounds each child id like ChildIDs does, and the trailing
     * `max=64` bounds each RFC3339Nano value. A bare `dive,max=64` would bound the
     * values only, leaving both the key length and the entry count unbounded.
     */
    expected_updated_at?: Record<string, string>;
    /**
     * TargetGroupID is the group the children move into.
     */
    target_group_id: string;
};
export namespace capacity_MoveAllocationsRequest {
    /**
     * AgeType is AUTO (derive per period from the billing age-transition rules),
     * BABY or CHILD (pin a literal age type for the whole period).
     */
    export enum age_type {
        AUTO = 'AUTO',
        BABY = 'BABY',
        CHILD = 'CHILD',
    }
}

